export enum GridConnection {
  EMPTY = null,
  OFFTAKE = 'offtake',
  INJECTION = 'injection',
}
